import React from 'react'
import styles from './Services.module.scss';
import Brand from '../../assets/brand-header.svg'
import Apple from '../../assets/apple-footer.png'
import Android from '../../assets/google-footer.png'
import Instagram from '../../assets/icon-instagram.png';
import Linked from '../../assets/icon-linked.png';
import Facebook from '../../assets/icon-facebook.png';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const renderIcons = () => (
    <div className={styles.contentIcons}>
        <img alt='brand' src={Brand} className={styles.brandImg} />
        <div className={styles.socials}>
            <img alt="instagram" src={Instagram} onClick={() => window.open("https://www.instagram.com", "_blank")} />
            <img alt="facebook" src={Facebook} onClick={() => window.open("https://www.facebook.com", "_blank")} />
            <img alt="linked" src={Linked} onClick={() => window.open("https://mx.linkedin.com", "_blank")} />
        </div>
    </div>
);

const renderList = () => (
    <div className={styles.contentList}>
        <div className={styles.list}>
            <p className='text-bold'>Living</p>
            <p>Nosotros</p>
            <p>Beneficios</p>
            <p>Contacto</p>
            <p>Login</p>
        </div>
        <div className={styles.list}>
            <p className='text-bold'>Productos</p>
            <p>Plataforma</p>
            <p>App</p>
            <p>
                Tarjetas<br />
                Corporativas
            </p>
        </div>
        <div className={styles.list}>
            <p className='text-bold'>Información legal</p>
            <p>
                Aviso de<br />
                privacidad
            </p>
            <p>
                Términos y<br />
                condifciones
            </p>
            <p>Aviso de Riesgo</p>
            <p>Política de Cookies</p>
        </div>
    </div>
);

const renderApps = () => (
    <div className={styles.contentApps}>
        <p className='text-bold'>Disponible en</p>
        <div className={styles.apps}>
            <img alt='ios' src={Apple} onClick={() => window.open("https://www.apple.com/mx/app-store", "_blank")} />
            <img alt='android' src={Android} onClick={() => window.open("https://play.google.com", "_blank")} />
        </div>
    </div>
)


export const Services = ({ ref }: any) => {
    const { isMobile } = useSelector((state: RootState) => state.data);
    
    return (
        <div className={styles.services} ref={ref}>
            <div className={styles.contentServices}>
                {
                    isMobile ? 
                        <>
                            {renderList()}
                            <div className={styles.contentMobile}>
                                {renderIcons()}
                                {renderApps()}
                            </div>
                        </>
                    :
                        <>
                            {renderIcons()}
                            {renderList()}
                            {renderApps()}
                        </>
                }


            </div>
        </div>
    )
}
